<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.chain"
        placeholder="选择链"
        clearable
        size="small"
        class="filter-item"
        style="width: 160px"
      >
        <el-option
          v-for="item in chainOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-input
        v-model="listQuery.keyword"
        placeholder="钱包地址"
        style="width: 240px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
      >
        搜索
      </el-button>
      <el-button
        class="filter-item"
        size="small"
        type="success"
        icon="el-icon-plus"
        @click="handleBatchAdd"
      >
        批量新增
      </el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      size="large"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="短剧ID" min-width="200" align="center">
        <template slot-scope="scope">
          {{ scope.row.video ? scope.row.video.id : `--` }}
        </template>
      </el-table-column>
      <el-table-column label="链" width="120" align="center">
        <template slot-scope="scope">
          {{ formatChain(scope.row.chain) }}
        </template>
      </el-table-column>
      <el-table-column label="钱包地址" min-width="260" align="center">
        <template slot-scope="scope">
          {{ scope.row.wallet_address }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="160"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-popconfirm
            title="确定删除该钱包地址吗？"
            @confirm="handleDelete(scope.row)"
          >
            <el-button slot="reference" size="mini" type="danger">
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      v-if="dialogVisible"
      title="批量新增钱包"
      :visible.sync="dialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="batchFormRef"
        :model="batchForm"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="链" required>
          <el-select
            v-model="batchForm.chain"
            placeholder="请选择链"
            style="width: 100%"
          >
            <el-option
              v-for="item in chainOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="钱包地址" required>
          <el-input
            v-model="batchForm.addressesText"
            type="textarea"
            :rows="6"
            placeholder="输入多个钱包地址，使用换行或逗号分隔"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="dialogSubmitting" @click="submitBatch">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "VideoWalletHub",
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        video_id: undefined,
        chain: undefined,
        keyword: undefined,
      },
      chainOptions: [
        { label: "Solana", value: "solana" },
        { label: "TON", value: "ton" },
        { label: "KAIA", value: "kaia" },
      ],
      dialogVisible: false,
      dialogSubmitting: false,
      batchForm: {
        chain: "solana",
        addressesText: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    formatChain(chain) {
      const target = this.chainOptions.find(
        (item) => item.value === (chain || "").toLowerCase()
      );
      return target ? target.label : chain;
    },
    buildQueryParams() {
      const params = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
      };
      if (this.listQuery.video_id) {
        params.video_id = this.listQuery.video_id;
      }
      if (this.listQuery.chain) {
        params.chain = this.listQuery.chain;
      }
      if (this.listQuery.keyword) {
        params.keyword = this.listQuery.keyword.trim();
      }
      return params;
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/admin/video-wallet-hub/list",
        method: "get",
        params: this.buildQueryParams(),
      })
        .then((response) => {
          this.list = response.data.data || [];
          this.total = response.data.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleBatchAdd() {
      this.batchForm = {
        chain: "solana",
        addressesText: "",
      };
      this.dialogVisible = true;
    },
    submitBatch() {
      if (!this.batchForm.chain) {
        this.$message.warning("请选择链");
        return;
      }

      const addresses = this.batchForm.addressesText
        .split(/[\r\n,，]+/)
        .map((item) => item.trim())
        .filter((item) => item);

      if (!addresses.length) {
        this.$message.warning("请至少输入一个钱包地址");
        return;
      }

      this.dialogSubmitting = true;
      request({
        url: "/api/admin/video-wallet-hub/batch-insert",
        method: "post",
        data: {
          chain: this.batchForm.chain,
          addresses,
        },
      })
        .then((response) => {
          this.$message.success(
            `新增成功，新增 ${response.data.inserted} 条`
          );
          this.dialogVisible = false;
          this.getList();
        })
        .finally(() => {
          this.dialogSubmitting = false;
        });
    },
    handleDelete(row) {
      request({
        url: "/api/admin/video-wallet-hub/delete",
        method: "post",
        data: { id: row.id },
      }).then(() => {
        this.$message.success("删除成功");
        this.getList();
      });
    },
  },
};
</script>

<style scoped>
.filter-item {
  margin-right: 10px;
}
</style>
